export default "__VITE_PUBLIC_ASSET__0c2a1599__"